module.exports = __webpack_public_path__ + "img/09_19.d65286af.png";